export function createContextMenuDynamicOptions<T extends Record<string, boolean>>(options: T, value: boolean): T {
  const result = {} as T;
  for (const key in options) {
    result[key] = value as T[typeof key];
  }
  return result as T;
}
